import { makeStyles } from '@mui/styles'
import { isDarkColor } from '@v4/utils'
import { dark, light } from '@mui/material/styles/createPalette'
import { isHtmlEmpty } from '@v4/hooks/useEditor/useEditor.utils'

const getColor = (palette, color) => {
	switch (color) {
		case 'text':
			return palette.text.secondary
		case 'secondary':
			return palette.secondary.main
		case 'white':
			return palette.common.white
		default:
			return palette.primary.main
	}
}

const useStyles = makeStyles(
	({ palette, spacing, typography }) => ({
		root: {
			color: ({ variant, color }) => {
				const currentColor = getColor(palette, color)

				switch (variant) {
					case 'outlined':
						return currentColor
					default:
						return isDarkColor(currentColor) ? dark.text.primary : light.text.primary
				}
			},
			borderRadius: ({ rounded }) => (rounded ? spacing(4) : null),
			'user-drag': 'none',
			'&:focus': {
				boxShadow: ({ color }) => {
					const currentColor = getColor(palette, color)
					return `0 0 0 2px ${isDarkColor(currentColor) ? palette.primary.light : palette.primary.dark}`
				},
			},
		},
		label: {
			textTransform: typography.button.textTransform || 'none',
			minWidth: '100%',
			textAlign: 'center',
			display: 'block',
		},
		progress: {
			position: 'absolute',
			top: '50%',
			left: '50%',
			marginTop: -12,
			marginLeft: -12,
		},
		editable: {
			cursor: 'text !important',
			position: 'relative',
			zIndex: 1,
			'&:hover, &:focus-visible, &.mce-edit-focus': {
				outline: ({ variant }) => {
					const color =
						variant === 'outlined'
							? palette.calcContrastColor(palette.scoreapp.primary, palette.background.default)
							: palette.calcContrastColor(palette.scoreapp.primary, palette.primary.main)
					return `1px dashed ${color} !important`
				},
			},
			'&[data-placeholder]': {
				position: 'relative',
				minHeight: '1.5em',
				'&::before': {
					content: props => (isHtmlEmpty(props.labelHtml) ? 'attr(data-placeholder)' : '"​"'),
					color: ({ variant }) =>
						palette.calcContrastColor(
							palette.scoreapp.placeholder,
							variant === 'outlined' ? palette.background.default : palette.primary.main,
						),
					position: 'absolute',
					left: 0,
					right: 0,
					bottom: 0,
					font: 'inherit',
					lineHeight: 'inherit',
					opacity: 0.6,
					transition: 'opacity 0.1s',
					fontWeight: 300,
					pointerEvents: 'none',
				},
				'&:not(:empty)::before': {
					opacity: 0,
					content: "''",
				},
			},
		},
		startIcon: {
			margin: 0,
		},

		outlined: {
			border: '1px solid currentColor',
			padding: spacing(1.5, 4),

			'&:hover': {
				border: '1px solid currentColor',
			},
		},
	}),
	{ name: 'EditableButton' },
)

export default useStyles
